export enum DashboardPeriodEnum {
  Today,
  Tomorrow,
  TodayAndTomorrow,
  UntilEndOfWeek,
  Next7Days,
  Next14Days,
  Yesterday,
  TodayAndYesterday,
  ThisWeek,
  Last7Days,
  Last14Days,
  OnDate,
  ForRange,
  PrepaymentPastDueDates,
  PrepaymentDueDates,
  Last30Days,
  PrepaymentsPaid
}

export enum ReservationsGridDefaultFilterByEnum {
  ArrivalDate = 1,
  DepartureDate = 2
}

export enum CurrencyEnum {
  HRK = 1,
  EUR = 2,
  USD = 3,
  GBP = 4,
  BAM = 5,
  RSD = 6
}

export enum CustomerTypeEnum {
  ReservationHolder = 1,
  Guest = 2,
  Owner = 3
}

export enum CategoriesEnum {
  Empty = 5,
  Star2 = 1,
  Star3 = 2,
  Star4 = 3,
  Star5 = 4
}

export enum PaymentMeansEnum {
  Novcanice = 1,
  TransakcijskiRacun = 2,
  OnlineServisZaPlacanje = 3,
  KreditnaKartica = 4,
  BankovnaKartica = 5,
  Cek = 6,
  Ostalo = 7
}

export enum FinancialDocumentTypesEnum {
  Racun = 1,
  Ponuda = 2,
  RacunZaPredujam = 3,
  Storno = 4,
  Otpremnica = 5,
  VlasnikovRacun = 6,
  RacunZaProviziju = 7,
  Uplatnica = 8,
  Isplatnica = 9
}

export enum FinancialDocumentStatusEnum {
  UIzradi = 1,
  Zakljucen = 2,
  Placen = 3,
  Dospio = 4,
  Storniran = 5,
  Istekla = 6
}

export enum UnitsOfMesureEnum {
  Kom = 1,
  Kpl = 2,
  Usluga = 3,
  Sat = 4,
  Dan = 5
}

export enum ReservationStatusEnum {
  Hold = 1,
  Confirmed = 2,
  Canceled = 3,
  CheckedIn = 4,
  CheckedOut = 5,
  NoShow = 6
}

export enum PriceCalculationMethodsEnum {
  PerStay = 1,
  PerNight = 2,
  PerPersonPerNight = 3,
  PerPerson = 4,
  PerAdultPerson = 5,
  Manual = 6,
  PerChildPerNight = 7,
  PerAdultPerNight = 8,
  PerDay = 9
}

export enum AccomodationUnitStatusEnum {
  Clean = 1,
  NeedsCleaning = 2,
  NeedsRepair = 3,
  CleaningInProgress = 4,
  RepairInProgress = 5
}

export enum TaxRatesEnum {
  Croatia25 = 1,
  Croatia13 = 2,
  VatOutOfScope = 3,
  VatExempt = 4,
  Bosnia17 = 5,
  BosniaZeroAndExempt = 6,
  Slovenia22 = 7,
  Slovenia95 = 8,
  Slovenia5 = 9,
  SloveniaOutOfScope = 10,
  Serbia20 = 11,
  Serbia10 = 12,
  SerbiaOutOfScope = 13,
}

export enum LineItemDistributionStrategy {
  SumDayPrices = 1,
  GroupByDayPrice = 2
}

export enum ReservationEVisitorCollapseExpandHideInfoEnum {
  Collapsed = 1,
  Expanded = 2,
  Hidden = 3
}

export enum TenantTypesEnum {
  PrivateOwner = 1,
  Agency = 2,
  Hotel = 3,
  Hostel = 4,
  Camp = 5
}

export enum ReservationGuestDisplayType {
  FullName = 1,
  Initials = 2
}

export enum GuestReviewStatusEnum {
  Submitted = 1,
  Approved = 2,
  Removed = 3
}

export enum OTAChannels {
  Booking = 1,
  AirBnB = 2,
  Priceline = 3,
  Expedia = 4,
  Tripadvisor = 5,
  Hotels = 6,
  Agoda = 7,
  Hostelworld = 8,
  Ctrip = 9,
  Oktogo = 10,
  Unknown = 11,
  HotelBeds = 12,
  Despegar = 13,
  VRBO = 14,
  Atraveo = 15,
  eDomizil = 17,
  TUIVillas = 18,
  KroatiDe = 19,
  Szallas = 20, // RevNGo
  GoogleVacationRentals = 21
}

export enum OwnerContractExportType {
  Resident = 1,
  NonResident = 2,
  LegalEntity = 3
}

export enum OfficialRatesExportType {
  InputPrice = 1,
  OutputPrice = 2,
  InputAndOutputPrice = 3
}

export enum RatePlansPromoCodeApplicationMethodsEnum {
  OnlyWithCode = 1,
  Always = 2
}

export enum InvoiceDefaultDeliveryDateEnum {
  ArrivalDate = 1,
  DepartureDate = 2
}

export enum OwnerPricingModelEnum {
  AbsoluteSame = 1,
  AbsoluteDifferent = 2,
  Relative = 3
}

export enum DistributionChannelEnum {
  OTA = 1,
  WalkIn = 2,
  Telephone = 3,
  Email = 4,
  Website = 5,
  Facebook = 6,
  PartnerAgency = 7,
  OTAconversion = 10,
  OwnersReservation = 11
}

export enum TenantCountryEnum {
  Croatia = 1,
  Slovenia = 2,
  Austria = 33
}

export enum PaymentGatewayIntegrationEnum {
  None = 0,
  Monri = 1,
  Nokumo = 2,
  WSPay = 3,
  NokumoPay = 4
}

export enum TransactiontypeEnum {
  Deposit = 1,
  Withdrawal = 2
}

export enum InvoiceStatusEnum {
  NotInvoiced = 1,
  FullyInvoiced = 2,
  PartiallyInvoiced = 3,
  OverInvoiced = 4,
  Undeterminable = 5,
  ManuallyOverriden = 6
}

export enum TenantStatusEnum {
  Deactivated = 0,
  Active = 1,
  ActiveSubscriptionExpired = 2,
  Suspended = 3,
  InternalUsage = 4,
  InFreeDemoPeriod = 5
}

export enum EVisitorIntegrationEnum {
  None = 0,
  HR = 1,
  SL = 2
}

export enum EVisitorIntegrationNameEnum {
  None = "None",
  HR = "eVisitor",
  SL = "eTurizem"
}

export enum EInvoiceIntegrationEnum {
  None = 0,
  ERacuni = 1
}

export enum EInvoiceStatusEnum {
  InPreparation = 1,
  InValidation = 2,
  Sent = 3,
  Delivered = 4,
  Canceled = 5,
  Unsuccessful = 6
}

export enum WhatsAppIntegrationStatusEnum {
  NotStarted = 1,
  Pending = 2,
  Active = 3,
  Error = 4
}